"use client";

import { SelectControl as DialKitVendorSelect } from "dialkit";
import { cn } from "../../../lib";
import { DialKitEmbeddedHost } from "./dialkit-embedded-host";
import "./dialkit-styles";

export interface DialKitSelectOption {
	value: string;
	label: string;
}

export interface DialKitSelectProps {
	label: string;
	value: string;
	options: Array<string | DialKitSelectOption>;
	onChange: (value: string) => void;
	disabled?: boolean;
	className?: string;
}

export function DialKitSelect({
	label,
	value,
	options,
	onChange,
	disabled = false,
	className,
}: DialKitSelectProps) {
	return (
		<DialKitEmbeddedHost
			data-dialkit-select=""
			className={cn(
				disabled && "pointer-events-none opacity-50",
				className,
			)}
		>
			<DialKitVendorSelect
				label={label}
				value={value}
				options={options}
				onChange={onChange}
			/>
		</DialKitEmbeddedHost>
	);
}
